const options = [
  {
    label: 'Новая заявка',
    code: 0,
    color: '#777'
  },
  {
    label: 'Целевая заявка',
    code: 1,
    color: '#090'
  },
  {
    label: 'Не оставляли заявку',
    code: 2,
    color: 'red'
  },
  {
    label: 'Некорректный номер',
    code: 3,
    color: 'red'
  },
  {
    label: 'Предложение рекламы',
    code: 4,
    color: 'red'
  },
  {
    label: 'Не дозвонились',
    code: 5,
    color: 'red'
  },
  {
    label: 'Дубль заявки',
    code: 6,
    color: 'red'
  },
  {
    label: 'За радиусом обслуживания',
    code: 7,
    color: 'red'
  },
  {
    label: 'В ближайшие 2 месяца не нужно',
    code: 9,
    color: 'red'
  },
  {
    label: 'Другое',
    code: 8,
    color: 'red'
  },
]

export default options;
